export const menuList = [
  {
    label: "Dashboard",
    path: "/dashboard",
    activePath: ["/dashboard"],
  },

  {
    label: "Main Menu",
    subMenu: [
      {
        label: "Profile",
        path: "/profile",
        activePath: ["/profile"],
      },
      {
        label: "Student Form",
        path: "/student-form",
        activePath: ["/student-form"],
      },
    ],
  },
  {
    label: "Internship",
    subMenu: [
      {
        label: "Request Form",
        path: "/request-form",
        activePath: ["/request-form"],
      },
    ],
  },
];
